import {AlertIcon} from '@primer/octicons-react'
import {OverviewMergeControl} from './shared/OverviewMergeControl'
import {ForYouItem} from '../shared/ForYouItem'
import {useMergeabilityData} from './use-mergeability-data'
import {ForYouLeadingIcon} from '../shared/ForYouLeadingIcon'
import {hasUnhandledMergeBlocker} from './merge-blocked-visibility'

export function shouldShowMergeBlocked(data: ReturnType<typeof useMergeabilityData>) {
  const blockedSection = data?.blockedSection

  return (
    !!data &&
    !data.isClosedOrMerged &&
    !data.mergeBoxPullRequest.isDraft &&
    !!blockedSection &&
    blockedSection.sectionStatus !== 'PASSED' &&
    hasUnhandledMergeBlocker(blockedSection.failingConditionsAndRules)
  )
}

// Catch-all "Needs attention" item shown to the author when the merge is blocked
// for a reason not covered by a more specific action item (e.g. a failing
// ruleset rule, an unmet merge condition, or an authorization policy).
export function MergeBlocked({variant}: {variant?: 'default' | 'embedded'}) {
  const data = useMergeabilityData()

  if (!shouldShowMergeBlocked(data)) return null

  return (
    <ForYouItem
      leadingVisual={<ForYouLeadingIcon icon={AlertIcon} variant="danger" />}
      title="Merge is blocked"
      itemName="merge-blocked"
      variant={variant}
      description={undefined}
      actionSlot={<OverviewMergeControl data={data} fallbackAction="view-status" itemName="merge-blocked" />}
    />
  )
}
